module.exports = __webpack_public_path__ + "img/builder-3.93655328.jpg";